// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__AgvjX","icon":"BackButton_icon__1DKEH","label":"BackButton_label__nP1sB"};